function f(r, t, i) {
  return r === null || typeof r != "object" ? r : Array.isArray(r) ? r.map((e) => f(e, t, i)).filter((e) => e !== void 0) : i(r) ? t(r) : Object.fromEntries(
    Object.entries(r).map(([e, n]) => [e, f(n, t, i)]).filter(([, e]) => e !== void 0)
  );
}
async function s(r, t, i) {
  return r === null || typeof r != "object" ? r : Array.isArray(r) ? (await Promise.all(
    r.map((e) => s(e, t, i))
  )).filter((e) => e !== void 0) : i(r) ? t(r) : Object.fromEntries(
    (await Promise.all(
      Object.entries(r).map(async ([e, n]) => [
        e,
        await s(n, t, i)
      ])
    )).filter(([, e]) => e !== void 0)
  );
}
export {
  f as traverseAndReplace,
  s as traverseAndReplaceAsync
};
//# sourceMappingURL=lib.es.js.map
